import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

import {Segment, Table} from "semantic-ui-react";

// services
import {PrivilegeDto} from "../../../services/Client";

export interface IPrivilegesTableProps extends ITranslatedComponent {
    /** Privilege objects to display in the table. */
    privileges: PrivilegeDto[];

    /** Whether or not the control is waiting for a response from the back end. */
    loading: boolean;
}

/**
 * A table-like component that displays a collection of PrivilegeDtos in a
 * structured way.
 */
export class PrivilegesTable extends React.Component<IPrivilegesTableProps> {
    renderHeader = (): JSX.Element => (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{this.props.t("IDENTIFIER")}</Table.HeaderCell>
                <Table.HeaderCell>{this.props.t("DESCRIPTION_DE")}</Table.HeaderCell>
                <Table.HeaderCell>{this.props.t("DESCRIPTION_EN")}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
    )

    renderPrivilegename = (dto: PrivilegeDto): JSX.Element => (
        <Table.Cell>{dto.identifier}</Table.Cell>
    )

    renderDescription = (dto: PrivilegeDto, desc: string): JSX.Element => (
        <Table.Cell>
            {
                desc === "DESCRIPTION_DE"
                    ? dto.descriptionDe
                    : dto.descriptionEn
            }
        </Table.Cell>
    )

    renderRows = (dtos: PrivilegeDto[]): JSX.Element[] => (
        dtos.map((dto, index) => (
            <Table.Row key={index}>
                {this.renderPrivilegename(dto)}
                {this.renderDescription(dto, "DESCRIPTION_DE")}
                {this.renderDescription(dto, "DESCRIPTION_EN")}
            </Table.Row>
        ))
    )

    renderTable = (dtos: PrivilegeDto[]): JSX.Element => (
        <Table>
            {this.renderHeader()}
            <Table.Body>
                {this.renderRows(dtos)}
            </Table.Body>
        </Table>
    )

    render() {
        return (
            <Segment loading={this.props.loading}>
                {this.renderTable(this.props.privileges)}
            </Segment>
        );
    }
}

export default translate("ADMIN_VIEW")(PrivilegesTable);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/PrivilegesTable.tsx